<div class="modal fade" tabindex="-1" role="dialog" id="rmpv-passagem-mensal-filtro">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 translate class="modal-title">{{'rmpv.passagem.filtros.definirFiltros'}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <!-- <div class="modal-body"> -->
        <div class="container striped-rows">
          <div class="row ptb5">
            <div translate class="col col-4">
              {{'rmpv.passagem.filtros.mercado'}}
            </div>
            <div class="col col-8">          
              <select class="form-control form-control-sm" type="text" placeholder="Selecione o Mercado..." [(ngModel)]="Mercado">
                <option translate value="">{{'rmpv.passagem.filtros.mercadoPlaceHolder'}}</option>
                <option *ngFor="let item of mercados" [value]="item.id">{{item.descricao}}</option>
              </select>
            </div>
          </div>
          <div class="row ptb5">
            <div translate class="col col-4">
              {{'rmpv.passagem.filtros.grupoEconomico'}}
            </div>
            <div class="col col-8">
              <select class="form-control form-control-sm" type="text" placeholder="Selecione o grupo econômico..." [value]="desabilitaDealer()" (change)="selecionaDealer()" [(ngModel)]="GrupoEconomico">
                  <option translate value="">{{'rmpv.passagem.filtros.grupoEconomicoPlaceHolder'}}</option>
                <option *ngFor="let item of gruposEconomicos"  [value]="item.id"> {{item.descricao}} </option>
              </select>
            </div>
          </div>
          <div class="row ptb5">
            <div translate class="col col-4">
              {{'rmpv.passagem.filtros.regiao'}}
            </div>
            <div class="col col-8">
              <select class="form-control form-control-sm" type="number" placeholder="Selecione a Região..." [value]="desabilitaRegional()" [(disabled)]="habRegiao" [(ngModel)]="Regiao">
              <option translate value="">{{'rmpv.passagem.filtros.regiaoPlaceHolder'}}</option>
              <option *ngFor="let item of regioes" [value]="item.id">{{item.descricao}}</option>
              </select>
            </div>
          </div>
          <div class="row ptb5">
            <div translate class="col col-4">
              {{'rmpv.passagem.filtros.regional'}}
            </div>
            <div class="col col-8">
              <select class="form-control form-control-sm" type="number" [value]="desabilitaRegiao()" [(disabled)]="habRegional" [(ngModel)]="Regional">
                <option translate value="">{{'rmpv.passagem.filtros.regiaoPlaceHolder'}}</option>
                <option *ngFor="let item of regionais" [value]="item.id">{{item.descricao}}</option>
              </select>
            </div>
          </div>
          <div class="row ptb5">
            <div translate class="col col-4">
              Dealer
            </div>
            <div class="col col-8">
              <select class="form-control form-control-sm" type="number" [value]="desabilitaGrupoEconomico()" [(ngModel)]="Dealer">
                <option translate value="">{{'rmpv.passagem.filtros.dealerPlaceHolder'}}</option>
                <option *ngFor="let item of dealers" [value]="item.id">{{item.descricao}}</option>
              </select>
            </div>
          </div>       
          <div class="row ptb5">
            <div translate class="col col-4">
                {{'rmpv.passagem.filtros.dataInicial'}}
            </div>
            <div class="col col-8">
              <div class="input-group input-group-sm ">
                  <input class="form-control" class="form-control" placeholder="{{'rmpv.passagem.filtros.dataInicialPlaceHolder' | translate}}" [(ngModel)]="InicialData" [(ngModel)]="DataInicial" [maxDate]="max" ngbDatepicker #dataInicialView="ngbDatepicker" (click)="dataInicialView.toggle()">
                  <div class="input-group-append"> 
                    <button class="btn btn-outline-secondary" (click)="dataInicialView.toggle()" type="button"> 
                      <em class="fa fa-calendar"></em>
                    </button>
                  </div>
                  <div class="input-group-append">
                    <button class="btn btn-outline-secondary" (click)="limparDataInicial(dataInicialView)" type="button">
                      <em class="fa fa-trash"></em>
                    </button>
                  </div>
                </div>
            </div>
          </div>  
          <div class="row ptb5">
            <div translate class="col col-4">
              {{'rmpv.passagem.filtros.dataFinal'}}
            </div>
            <div class="col col-8">
              <div class="input-group input-group-sm ">
                  <input class="form-control" class="form-control" placeholder="{{'rmpv.passagem.filtros.dataFinalPlaceHolder' | translate}}" [(ngModel)]="FinalData" [(ngModel)]="DataFinal" 
                  [maxDate]="max" ngbDatepicker #dataFinalView="ngbDatepicker" (click)="dataFinalView.toggle()">
                  <div class="input-group-append">
                    <button class="btn btn-outline-secondary" (click)="dataFinalView.toggle()" type="button">
                      <em class="fa fa-calendar"></em>
                    </button>
                  </div>
                  <div class="input-group-append">
                    <button class="btn btn-outline-secondary" (click)="limparDataFinal(dataFinalView)" type="button">
                      <em class="fa fa-trash"></em>
                    </button>
                  </div>
                </div>
            </div>
          </div>
        </div>
      <!-- </div> -->
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="Mercado() || GrupoEconomico() || Regiao() || Regional() || Dealer() || limparDataInicial(dataInicialView) || limparDataFinal(dataFinalView)">
          <i class="fa fa-trash" aria-hidden="true"></i>
        </button>
        <button type="button" class="btn btn-info" data-dismiss="modal">OK</button>
      </div>
    </div>
  </div>
</div>